import { clsx } from 'clsx'

import { VideoPlayer } from '../../../Common/VideoPlayer'
import type { PlayerProps } from '../../../Common/VideoPlayer'

import styles from './AttachmentVideo.module.css'

import type { JSX } from 'react'

const AttachmentVideo = (props: PlayerProps): JSX.Element => (
  // No autoPlay here. It downloads the video from S3 for every Threads preview, which costs a few thousand USD a month in egress.
  <VideoPlayer
    {...props}
    className={clsx(styles.videoPlayer, props.className)}
  />
)

export { AttachmentVideo }
